import React, { useEffect }                     from 'react'
import axios                                    from 'axios'
import { node_server }                          from '../../Helpers'
import PropTypes                                from 'prop-types'

const GetMalformedUsernamesComponent = ( { setNumMalformedUsers } ) => {


   useEffect( () => {
      axios.get(node_server + 'admin/analytics/getMalformedUsernames')
         .then( res => {
            setNumMalformedUsers(res.data.numMalformedUsers)
         } )
         .catch( (error) => {
            console.error(error)
         } )
   }, [] )

   return(
      null
   )
}

GetMalformedUsernamesComponent.propTypes = {
   setNumMalformedUsers:                        PropTypes.func
}

export default GetMalformedUsernamesComponent
